import { render, staticRenderFns } from "./ReportTypeInputConfig.vue?vue&type=template&id=23502059&scoped=true"
import script from "./ReportTypeInputConfig.vue?vue&type=script&lang=js"
export * from "./ReportTypeInputConfig.vue?vue&type=script&lang=js"
import style0 from "./ReportTypeInputConfig.vue?vue&type=style&index=0&id=23502059&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23502059",
  null
  
)

export default component.exports